import {getValidatedRedirectUrlOrFallback} from 'app/helpers/validateRedirectUrl';

const getValidatedRedirectUrl = () => {
  const redirectUrl = new URLSearchParams(window.location.search).get('redirectUrl');
  const validatedRedirectUrl = getValidatedRedirectUrlOrFallback(redirectUrl);
  return window.location.origin + validatedRedirectUrl;
};

export {getValidatedRedirectUrl};
